import { render, staticRenderFns } from "./boardBGColor.vue?vue&type=template&id=55286cab&"
import script from "./boardBGColor.vue?vue&type=script&lang=js&"
export * from "./boardBGColor.vue?vue&type=script&lang=js&"
import style0 from "./boardBGColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports